import React from "react";
import "./accreditations.css";

const Accreditations = () => {
  const accreditations = [
    {
      title:
        "Comprehensive Inspection Program Of Directorate General Of Shipping: Govt. Of India IRQS ISO 9001:2015",
      link: "https://manetpune.edu.in/assets_web/pdf/CIP_INSPECTION_CERTIFICATE-2024.pdf",
    },
    {
      title:
        "IRQS ISO 9001:2015 (MANET is an ISO 9001:2015 certified institute)",
      link: "https://manetpune.edu.in/assets_web/pdf/ISO_Certificate.pdf",
    },
    {
      title:
        "Ministry Of Land, Infrastructure, Transport, And Tourism (MLIT), JAPAN",
      link: "https://manetpune.edu.in/assets_web/pdf/MANET-Continuation_of_Recognition_(notification)-_15th_Nov_2019.pdf",
    },
    {
      title:
        "Ship-In-Campus Accreditation From, Directorate General Of Shipping: Govt. Of India ",
      link: "https://manetpune.edu.in/assets_web/pdf/ship.jpg",
    },
    {
      title:
        "Affiliated University - B. Tech Marine Engineering And B.Sc. Nautical Science Courses Are Approved By MIT ADT University, Pune",
      link: "https://mituniversity.ac.in/",
    },
  ];

  return (
    <div>
      <h1 className="title">Accreditations & Approvals</h1>
      <hr />
      <div className="acc-content-container">
        {/* Cards Section */}
        <h4 className="acc-section-subtitle">
          MANET has got the Accreditations and Approvals from the following well
          known organizations :
        </h4>
        <div className="acc-cards-section">
          {accreditations.map((item, index) => (
            <div className="acc-card" key={index}>
              <div className="acc-card-text">
                <h3>{item.title}</h3>
              </div>
              <button className="page-content-btn">
                <a href={item.link} target="_blank" rel="noopener noreferrer">
                  View Certificate
                </a>
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Accreditations;
